import { flow, pick, map, get } from 'lodash/fp';

import { getPrice, getMonthlyPrice } from 'helpers/ad/price';
import { getMainImage } from 'helpers/ad/getImageUrl';

const getMileage = get(['mileage', 'distance']);
const getAdPrice = flow(get(['offerPrice', 'amountMinorUnits']), getPrice);
const getAdMonthlyPrice = flow(get(['monthlyPayment']), getMonthlyPrice);

const AD_FIELDS = [
  'bodyType',
  'co2Value',
  'contact',
  'exclusive',
  'firstRegistrationYear',
  'fuelConsumption',
  'fuelType',
  'gearType',
  'has360Images',
  'horsePower',
  'id',
  'kw',
  'location',
  'manufacturer',
  'model',
  'monthlyPayment',
  'pathTitle',
  'registration',
  'sellerType',
  'sellerName',
  'sellerLogo',
  'subtitle',
  'subType',
  'subTypeExtra',
  'title',
  'vatRate',
  'isFavorite',
  'isDislike',
  'published',
];

export const getAds = flow(
  get(['result', 'response', 'hits', 'hits']),
  map(
    flow(get(['_source']), (ad) => ({
      ...pick(AD_FIELDS, ad),
      image: getMainImage(ad),
      mileage: getMileage(ad),
      monthlyPrice: getAdMonthlyPrice(ad),
      price: getAdPrice(ad),
    })),
  ),
);
